import { render, staticRenderFns } from "./PaymentsAndCurrenciesP2PPayments.vue?vue&type=template&id=360c093c&scoped=true&"
import script from "./PaymentsAndCurrenciesP2PPayments.vue?vue&type=script&lang=js&"
export * from "./PaymentsAndCurrenciesP2PPayments.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsAndCurrenciesP2PPayments.vue?vue&type=style&index=0&id=360c093c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360c093c",
  null
  
)

export default component.exports